import { Typography } from '@mui/material';
import { IYieldSummary, WeightUnitEnum } from 'interfaces/erms';
import { FC, useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { mapViewSelector } from 'store/slices/mapViewSlice';
import ContainerBox from '../../components/ContainerBox';
import SelectYieldUnit from './SelectYieldUnit';
import YieldLineChart from './YieldLineChart';

interface YieldBoxProps {
  setHoverDatePoint: (arg: string) => void;
  yieldChartData: IYieldSummary[];
  area: number;
  totalTree: number;
}

const YieldBox: FC<YieldBoxProps> = ({ setHoverDatePoint, yieldChartData, area, totalTree }) => {
  const [yieldUnit, setYieldUnit] = useState<WeightUnitEnum>(WeightUnitEnum.METRIC_TONNE);
  const { levelId } = useAppSelector(mapViewSelector);

  // reset yield options when changing levelId
  useEffect(() => {
    setYieldUnit(WeightUnitEnum.METRIC_TONNE);
  }, [levelId]);

  return (
    <ContainerBox>
      <Typography fontSize="16px" mb="8px" fontWeight={600}>
        Yield
      </Typography>
      <SelectYieldUnit yieldUnit={yieldUnit} setYieldUnit={setYieldUnit} area={area} totalTree={totalTree} />
      <YieldLineChart
        yieldChartData={yieldChartData}
        yieldUnit={yieldUnit}
        area={area}
        totalTree={totalTree}
        setHoverDatePoint={setHoverDatePoint}
      />
    </ContainerBox>
  );
};

export default YieldBox;
